export default __webpack_public_path__ + "096d191f80751933ae936dbe12274941.png";